// extracted by mini-css-extract-plugin
export default {"YoutubeEmbed":"baz_a"};